module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Mail-opened-a14d662f21051e8f7cc7adcdbdab5938.svg";